import { ComputedRef, ref, Ref, unref, watch } from 'vue';
import scrollService from '@/core/scroll/scroll.service';

export default function useScrollToElement(scroll: Ref<boolean> | ComputedRef<boolean>, offset: number | ComputedRef<number> = 0, delay: number = 400, allowScrollUp: boolean = true) {
    const element: Ref<HTMLElement|undefined> = ref();
    const functionRef = el => {
        element.value = el;
    };

    watch(scroll, (scroll) => {
        const unwrappedOffset = unref(offset);
        if (scroll && element.value) {
            window.setTimeout(() => {
                if (!element.value) {
                    return;
                }
                const to = element.value.offsetTop + unwrappedOffset;
                const shouldScroll = allowScrollUp || window.scrollY < to;
                if (shouldScroll) {
                    scrollService.smoothScroll(to);
                }
            }, delay);
        }
    }, { immediate: true });

    return functionRef;
}
